/* global Swiper */

/*
 * Swiper for customer quotes in hero
 */
(function () {
	"use strict";

	new Swiper('.swiper-container', {
		// Optional parameters
		loop: true,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: 'bullets'
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true
		},
	});

}());